import {formatChartPeriod} from './chart-period';

import type {HistoryChartData} from './chart-data';
import type {ChartLabelOptions} from './chart-period';
import type {ProductHistoryPeriod} from 'src/openapi/admin/models/ProductHistoryPeriod';
import type {ProductHistorySeries} from 'src/openapi/admin/models/ProductHistorySeries';

const GOLDEN_ANGLE = 137.508;
const colorFor = (index: number) => {
    const hue = (190 + index * GOLDEN_ANGLE) % 360;
    const lightness = index % 2 === 0 ? 0.46 : 0.6;
    const amplitude = 0.65 * Math.min(lightness, 1 - lightness);
    const channel = (offset: number) => {
        const position = (offset + hue / 30) % 12;
        const value = lightness - amplitude * Math.max(-1, Math.min(position - 3, 9 - position, 1));
        return Math.round(value * 255).toString(16).padStart(2, '0');
    };
    return `#${channel(0)}${channel(8)}${channel(4)}`;
};

export const buildProductChartData = (
    products: ProductHistorySeries[], rows: ProductHistoryPeriod[], hidden: Set<string>,
    labelOptions: ChartLabelOptions,
): HistoryChartData => ({
    categories: [{category: rows.map(row => ({
        label: formatChartPeriod(row.periodStart, row.periodEnd, labelOptions),
    }))}],
    dataset: products.map((product, index) => ({
        id: product.productKey,
        seriesName: products.filter(item => item.productName === product.productName).length > 1
            ? `${product.productName} (${product.productKey})` : product.productName,
        color: colorFor(index),
        initiallyHidden: hidden.has(product.productKey) ? '1' : '0',
        data: hidden.has(product.productKey) ? []
            : rows.map(row => ({value: row.countsByProduct[product.productKey] ?? 0})),
    })),
});
